<template>
  <div class="footer">
    <div class="footer__help-buttons">
      <app-button :text="$t('footer.isThisLegal')" :action="isThisLegal"></app-button>
      <app-button :text="$t('footer.iHaveAQuestion')" :action="question" v-if="$store.getters.config('company_questions_signing') > 0"></app-button>
    </div>
    <app-button :text="$store.getters.footerNextButtonText()" :action="nextField" classList="button--cta float-right"></app-button>
    <div class="footer__info float-right">{{ requiredItems }}</div>
  </div>
</template>

<script>
  import AppButton from '@/components/AppButton';
  import { submitEnvelope } from '@/store/api';

  export default {
    name: 'footer',
    components: {
      AppButton,
    },
    data() {
      return {
        nextFieldText: this.$store.getters.footerNextButtonText(),
        doneFields: this.$store.getters.doneFields(),
        requiredFields: this.$store.getters.requiredFieldsForParty,
      };
    },
    created() {
      this.$bus.$on('addedNewDoneField', () => {
        this.buttonCheck();
        this.doneFields = this.$store.getters.doneFields();
      });
      this.$bus.$on('nextDocument', () => {
        this.buttonCheck();
      });
    },
    computed: {
      requiredItems() {
        return `${this.itemsToComplete()}`;
      },
    },
    methods: {
      isThisLegal() {
        this.$bus.$emit('openModal', 'helpModal');
        this.$bus.$emit('selectTab', 'is-this-legal');
      },
      question() {
        this.$bus.$emit('openModal', 'helpModal');
        this.$bus.$emit('selectTab', 'contact-signable-team');
      },
      nextField() {
        const isEnvelopeDone = this.$store.getters.isEnvelopeComplete();
        const isDocumentDone = this.$store.getters.isDocumentDone();
        const nextField = this.$store.getters.nextField();
        if (isEnvelopeDone) {
          if (window.IS_PREVIEW) {
            alert(this.$t('footer.signPreviewWarning'));
          } else {
            this.$bus.$emit('loading');
            submitEnvelope({ store: this.$store })
              .then((response) => {
                this.$bus.$emit('submitEnvelope', { response });
              });
          }
        } else if (isDocumentDone) {
          this.$store.dispatch('nextDocument');
          this.$bus.$emit('nextDocument');
        } else {
          this.$store.commit('setActiveStates', {
            currentPage: nextField.page,
            currentField: nextField.index,
            activePopupId: nextField.id,
          });
          this.$bus.$emit('nextField', { inputId: nextField.id });
          this.$bus.$emit('scrollBody');
          this.$bus.$emit('openedFieldPopup', { field: nextField });
          if (nextField.type === 'checkbox') {
            this.$bus.$emit('highlightField', { field: nextField });
          }
        }
        this.nextFieldText = this.$store.getters.footerNextButtonText();
      },
      buttonCheck() {
        this.nextFieldText = this.$store.getters.footerNextButtonText();
      },
      itemsToComplete() {
        const requiredFields = this.$store.getters.removeFieldGroups(this.requiredFields);
        const doneFields = this.$store.getters.removeFieldGroups(this.doneFields);
        if (requiredFields.length - doneFields.length === 0) {
          return this.$t('footer.allComplete');
        } else if (requiredFields.length - doneFields.length === 1) {
          return this.$t('footer.oneToComplete');
        }
        return this.$t('footer.pluralToComplete', { count: requiredFields.length - doneFields.length });
      },
    },
  };
</script>

<style lang="sass" scoped>
  @import '~styles/component-utils.sass'
  .footer
    background-color: #fff
    position: fixed
    bottom: 0
    right: 0
    width: 75%
    padding: $spacing-base
    box-shadow: 0px -15px 15px -20px $color-grey
    @include clearfix
    a
      margin-left: $spacing-base
      &:first-child
        margin-left: 0
      &.float-right
        margin-left: 0
    &__info
      padding: $spacing-small + 2
      color: $color-main-dark
      font-weight: bold
  // Responsive
  @media screen and (max-width: $screen-size-large)
    .footer
      width: 100%
      &__help-buttons
        display: none
</style>



// WEBPACK FOOTER //
// Footer.vue?b064461a